export default "__VITE_ASSET__DQFXuvso__"